import { AwardsApi } from '../clients';

export const updateMembershipStatus = (cycleId, userId, status) =>
  AwardsApi.updateMembershipStatus(cycleId, userId, status);
